<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.91 19.09">
    <defs></defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="transport">
        <path
          class="cls-1"
          d="M27,15.83a3.27,3.27,0,1,1,3.27,3.26A3.28,3.28,0,0,1,27,15.83Zm.93,0a2.34,2.34,0,1,0,2.34-2.34A2.34,2.34,0,0,0,27.9,15.83Z"
        />
        <path
          class="cls-1"
          d="M5.18,15.83a3.27,3.27,0,1,1,3.27,3.26A3.28,3.28,0,0,1,5.18,15.83Zm.93,0a2.34,2.34,0,1,0,2.34-2.34A2.34,2.34,0,0,0,6.11,15.83Z"
        />
        <path
          class="cls-1"
          d="M15.29,16.29h12a.47.47,0,0,0,0-.93H15.75V11.08h20a.25.25,0,0,1,.25.25v3.78a.25.25,0,0,1-.25.25H33.17a.47.47,0,0,0,0,.93h2.57a1.17,1.17,0,0,0,1.17-1.18V11.33a1.17,1.17,0,0,0-1.17-1.18H15.29a.47.47,0,0,0-.47.46v5.22A.47.47,0,0,0,15.29,16.29Z"
        />
        <path
          class="cls-1"
          d="M3.91,9.61a.49.49,0,0,1,0-.44l2.29-5.1a.47.47,0,0,1,.43-.28H9.15a.47.47,0,0,1,.46.47v5.1a.47.47,0,0,1-.46.46H4.3A.48.48,0,0,1,3.91,9.61ZM8.68,4.72H6.89L5,8.9H8.68Z"
        />
        <path
          class="cls-1"
          d="M1.11,16.29H5.43a.47.47,0,0,0,0-.93H1.11a.18.18,0,0,1-.18-.19V14a.18.18,0,0,1,.18-.18H1.7a.47.47,0,0,0,.46-.47V9.64a.54.54,0,0,1,0-.21l3-6.65a.51.51,0,0,1,.46-.3h8.69a.5.5,0,0,1,.5.51V15.36H11.37a.47.47,0,1,0,0,.93h3.92a.47.47,0,0,0,.46-.46V3a1.43,1.43,0,0,0-1.43-1.43H5.63a1.44,1.44,0,0,0-1.31.85l-3,6.65a1.43,1.43,0,0,0-.12.58v3.25H1.11A1.11,1.11,0,0,0,0,14v1.17A1.12,1.12,0,0,0,1.11,16.29Z"
        />
        <path
          class="cls-1"
          d="M17,10.61V.46A.46.46,0,0,1,17.49,0H34.84a.47.47,0,0,1,.46.46V10.61a.47.47,0,0,1-.46.47H17.49A.46.46,0,0,1,17,10.61ZM34.38.93H18v9.22H34.38Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>
<style scoped>
.cls-1 {
  fill: #fff;
  stroke: #fff;
  stroke-miterlimit: 10;
  stroke-width: 0.92px;
}
</style>
